import { render, staticRenderFns } from "./YouTubeVideo.vue?vue&type=template&id=0f294fa5&"
import script from "./YouTubeVideo.vue?vue&type=script&lang=js&"
export * from "./YouTubeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports